import type { PlayerTeleportedEvent } from '../../../shared/types/NetworkMessages';

/** The wire shape the client handler sees: older senders keyed by sessionId. */
export type TeleportChatMessage = Partial<Pick<PlayerTeleportedEvent, 'playerId' | 'position' | 'reason'>> & {
  sessionId?: string;
};

/**
 * The "Teleported to (x, y)" chat line for a `playerTeleported` that moved the
 * LOCAL player, or null when there is nothing to say.
 *
 * A `claim_resync` snap is the server correcting a desynced client, not a
 * teleport the player asked for, so it prints nothing (plan 21 B5: a `/tp`
 * used to be followed by a resync at the same spot, printing the line twice).
 */
export function teleportChatLine(
  message: TeleportChatMessage | null | undefined,
  localIds: ReadonlyArray<string | undefined | null>,
): string | null {
  if (!message || message.reason === 'claim_resync') return null;
  const ids = new Set(localIds.map(id => String(id || '')).filter(Boolean));
  if (!ids.has(String(message.playerId || '')) && !ids.has(String(message.sessionId || ''))) return null;
  return `✨ Teleported to (${Math.round(message.position?.x ?? 0)}, ${Math.round(message.position?.y ?? 0)})`;
}
